import Routes from '../../Routes';
import Header from '../Header';
import SidebarMenu from '../SidebarMenu';
import Flyout from '../Flyout';
import Alert from '../Alert';

function Dashboard() {
  return (
    <>
      <Alert />
      <Header />
      <SidebarMenu />
      <main>
        <Routes />
      </main>
      <Flyout />
    </>
  );
}

export default Dashboard;
